<template>
  <svg
    class="icon"
    width="49"
    height="48"
    viewBox="0 0 49 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M41.318 18.7059C42.2786 19.2167 43.0821 19.9793 43.6424 20.9119C44.2027 21.8444 44.4988 22.9119 44.4988 23.9999C44.4988 25.0879 44.2027 26.1553 43.6424 27.0879C43.0821 28.0205 42.2786 28.7831 41.318 29.2939L15.694 43.2279C11.568 45.4739 6.5 42.5539 6.5 37.9359V10.0659C6.5 5.44588 11.568 2.52788 15.694 4.76988L41.318 18.7059Z"
    />
  </svg>
</template>
